import React from "react";
import {useSelector, useDispatch} from "react-redux";

import * as actionTypes from "../../store/actions/actionTypes";

const Admission_Pdf = ({admission}) => {
    const idToken = useSelector(state => state.auth.idToken);
    const dispatch = useDispatch();
    const ref = React.useRef(null);

    // IMP-804 - per-hospital toggle: open documents in an in-browser modal
    // (with print) instead of downloading the file. Defaults to download.
    const useModal = admission.hospital && admission.hospital.manager_bulkDocumentsDownload_useModal;

    const downloadPdf = () => {
        ref.current.submit();
    }

    const showModal = () => {
        dispatch({type: actionTypes.MODAL_ADMISSION_BULK_PDF_SHOW, admission});
    }

    if (admission.haveDocuments) {
        return (
            <button className="btn btn-sm btn-white-primary" onClick={useModal ? showModal : downloadPdf}>
                <i className="icon ico-document-with-conner"/>
                <span>Patient Ad Docs</span>
                {admission.isStatusPP_documentsMerged &&
                <div className="icon-check text-success" style={{marginLeft: '5px'}}>
                    <i className="icon ico-c-check"/>
                </div>
                }
                {!useModal &&
                <div style={{display: 'none'}}>
                    <form action={`${process.env.REACT_APP_API_PATH}/admission/${admission.id}/pdf`} method="post"
                          ref={ref}>
                        <input type="hidden" name="token" value={idToken}/>
                    </form>
                </div>
                }
            </button>
        );
    } else {
        return (
            <button className="btn btn-sm btn-white-primary disabled" disabled={true}>
                <i className="icon ico-document-with-conner"/>
                <span>Patient Ad Docs</span>
            </button>
        );
    }
}

export default Admission_Pdf;
